module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }